// import React, { useEffect, useState } from "react";
// import { useAuth } from "./App";
// import { API_URL } from "./config";
// import {
//   Container,
//   Typography,
//   Box,
//   Paper,
//   Grid,
//   Toolbar,
//   CircularProgress,
//   IconButton,
//   Tooltip,
// } from "@mui/material";
// import OverviewCards from "./components/admin_dashboard/OverviewCards";
// import RecentActivityFeed from "./components/admin_dashboard/RecentActivityFeed";
// import JobOrderPerformance from "./components/admin_dashboard/JobOrderPerformance";
// import CandidatePipelineFunnel from "./components/admin_dashboard/CandidatePipelineFunnel";
// import InterviewCalendarWidget from "./components/admin_dashboard/InterviewCalendarWidget";
// import AIInsightsAnalytics from "./components/admin_dashboard/AIInsightsAnalytics";
// import TasksReminders from "./components/admin_dashboard/TasksReminders";
// import EmailNotificationSummary from "./components/admin_dashboard/EmailNotificationSummary";
// import QuickActions from "./components/admin_dashboard/QuickActions";
// import EventScheduleModalV2 from "./components/EventScheduleModalV2";
// import SystemHealth from "./components/admin_dashboard/SystemHealth";
// import CustomizableWidgets from "./components/admin_dashboard/CustomizableWidgets";
// import { useLocation, useNavigate } from "react-router-dom";
// import { colors } from "./theme";
// import AdminSidebar from "./AdminSidebar";
// import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

// export default function AdminDashboard() {
//   // --- Event Schedule Modal State ---
//   const [eventModalOpen, setEventModalOpen] = useState(false);

//   const handleScheduleEvent = async (eventData) => {
//     try {
//       const res = await fetchWithAuth(`${API_URL}/events/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(eventData),
//       });
//       if (!res.ok) {
//         const err = await res.json();
//         throw new Error(err.detail || "Failed to schedule event");
//       }
//       setEventModalOpen(false);
//       return true;
//     } catch (err) {
//       throw err;
//     }
//   };

//   const navigate = useNavigate();

//   // --- Widget Visibility State ---
//   const [showCustomize, setShowCustomize] = useState(false);
//   const [widgets, setWidgets] = useState([
//     { key: "overview", label: "Overview Cards", enabled: true },
//     { key: "activity", label: "Recent Activity", enabled: true },
//     { key: "performance", label: "Job Order Performance", enabled: true },
//     { key: "funnel", label: "Candidate Funnel", enabled: true },
//     { key: "calendar", label: "Interview Calendar", enabled: true },
//     { key: "ai", label: "AI Insights", enabled: true },
//     { key: "tasks", label: "Tasks & Reminders", enabled: true },
//     { key: "emails", label: "Email/Notification Summary", enabled: true },
//     { key: "quick", label: "Quick Actions", enabled: true },
//     { key: "health", label: "System Health", enabled: true },
//   ]);

//   const handleToggleWidget = (key) => {
//     setWidgets((widgets) =>
//       widgets.map((w) => (w.key === key ? { ...w, enabled: !w.enabled } : w))
//     );
//   };
//   // --- END Widget Visibility State ---

//   const { auth, isAuthenticated, fetchWithAuth } = useAuth();
//   const location = useLocation();
//   const [jobOrders, setJobOrders] = useState([]);
//   const [orgs, setOrgs] = useState([]);
//   const [error, setError] = useState("");
//   const [open, setOpen] = useState(false);
//   const [form, setForm] = useState({
//     title: "",
//     company_name: "",
//     location: "",
//     description: "",
//     is_public: true,
//   });
//   const [editOpen, setEditOpen] = useState(false);
//   const [editForm, setEditForm] = useState(null);
//   const [deleteOpen, setDeleteOpen] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);

//   // Dashboard widget state
//   const [overviewStats, setOverviewStats] = useState({
//     jobOrders: 0,
//     applications: 0,
//     hires: 0,
//     interviews: 0,
//     newCandidates: 0,
//   });
//   const [activityFeed, setActivityFeed] = useState([]);
//   const [jobPerformance, setJobPerformance] = useState([]);
//   const [pipelineFunnel, setPipelineFunnel] = useState([]);
//   const [interviewEvents, setInterviewEvents] = useState([]);
//   const [aiInsights, setAiInsights] = useState({
//     topMatched: [],
//     parsingStats: {},
//     diversity: {},
//   });
//   const [tasks, setTasks] = useState([]);
//   const [emailSummary, setEmailSummary] = useState([]);
//   const [systemHealth, setSystemHealth] = useState({
//     api: "ok",
//     integrations: [],
//     errors: [],
//   });

//   // Dashboard widget data fetching (sequential, with individual loaders)
//   const [loadingOverview, setLoadingOverview] = useState(false);
//   const [loadingActivity, setLoadingActivity] = useState(false);
//   const [loadingPerformance, setLoadingPerformance] = useState(false);
//   const [loadingFunnel, setLoadingFunnel] = useState(false);
//   const [loadingInterviews, setLoadingInterviews] = useState(false);
//   const [loadingAI, setLoadingAI] = useState(false);
//   const [loadingTasks, setLoadingTasks] = useState(false);
//   const [loadingEmails, setLoadingEmails] = useState(false);
//   const [loadingSystemHealth, setLoadingSystemHealth] = useState(false);

//   useEffect(() => {
//     let cancelled = false;
//     async function fetchDashboardData() {
//       if (!isAuthenticated || !auth?.access_token) return;

//       setLoadingOverview(true);
//       try {
//         const res = await fetchWithAuth(`${API_URL}/dashboard/overview`);
//         const data = await res.json();
//         if (!cancelled) setOverviewStats(data);
//       } catch {
//         if (!cancelled)
//           setOverviewStats({
//             jobOrders: 0,
//             applications: 0,
//             hires: 0,
//             interviews: 0,
//             newCandidates: 0,
//           });
//       } finally {
//         setLoadingOverview(false);
//       }

//       setLoadingActivity(true);
//       try {
//         const res = await fetchWithAuth(`${API_URL}/dashboard/activity`);
//         const data = await res.json();
//         if (!cancelled) setActivityFeed(Array.isArray(data) ? data : []);
//       } catch {
//         if (!cancelled) setActivityFeed([]);
//       } finally {
//         setLoadingActivity(false);
//       }

//       setLoadingPerformance(true);
//       try {
//         const res = await fetchWithAuth(`${API_URL}/dashboard/performance`);
//         const data = await res.json();
//         if (!cancelled) setJobPerformance(Array.isArray(data) ? data : []);
//       } catch {
//         if (!cancelled) setJobPerformance([]);
//       } finally {
//         setLoadingPerformance(false);
//       }

//       setLoadingFunnel(true);
//       try {
//         const res = await fetchWithAuth(`${API_URL}/dashboard/funnel`);
//         const data = await res.json();
//         if (!cancelled) setPipelineFunnel(Array.isArray(data) ? data : []);
//       } catch {
//         if (!cancelled) setPipelineFunnel([]);
//       } finally {
//         setLoadingFunnel(false);
//       }

//       setLoadingInterviews(true);
//       try {
//         const res = await fetchWithAuth(`${API_URL}/dashboard/interviews`);
//         const data = await res.json();
//         if (!cancelled) setInterviewEvents(Array.isArray(data) ? data : []);
//       } catch {
//         if (!cancelled) setInterviewEvents([]);
//       } finally {
//         setLoadingInterviews(false);
//       }

//       setLoadingAI(true);
//       try {
//         const res = await fetchWithAuth(`${API_URL}/dashboard/ai-insights`);
//         const data = await res.json();
//         if (!cancelled) setAiInsights(data);
//       } catch {
//         if (!cancelled)
//           setAiInsights({
//             topMatched: [],
//             parsingStats: {},
//             diversity: {},
//           });
//       } finally {
//         setLoadingAI(false);
//       }

//       setLoadingTasks(true);
//       try {
//         const res = await fetchWithAuth(`${API_URL}/dashboard/tasks`);
//         const data = await res.json();
//         if (!cancelled) setTasks(Array.isArray(data) ? data : []);
//       } catch {
//         if (!cancelled) setTasks([]);
//       } finally {
//         setLoadingTasks(false);
//       }

//       setLoadingEmails(true);
//       try {
//         const res = await fetchWithAuth(`${API_URL}/dashboard/emails`);
//         const data = await res.json();
//         if (!cancelled) setEmailSummary(Array.isArray(data) ? data : []);
//       } catch {
//         if (!cancelled) setEmailSummary([]);
//       } finally {
//         setLoadingEmails(false);
//       }

//       setLoadingSystemHealth(true);
//       try {
//         const res = await fetchWithAuth(
//           `${API_URL}/dashboard/system-health`
//         );
//         const data = await res.json();
//         if (!cancelled) setSystemHealth(data);
//       } catch {
//         if (!cancelled)
//           setSystemHealth({ api: "ok", integrations: [], errors: [] });
//       } finally {
//         setLoadingSystemHealth(false);
//       }
//     }
//     fetchDashboardData();
//     return () => {
//       cancelled = true;
//     };
//   }, [isAuthenticated, auth, fetchWithAuth]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
//   };
//   const handleEditChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setEditForm((f) => ({
//       ...f,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleCreate = async () => {
//     setError("");
//     try {
//       const res = await fetchWithAuth("/job-orders/", {
//         method: "POST",
//         body: JSON.stringify(form),
//       });
//       if (!res.ok)
//         throw new Error(
//           (await res.json()).detail || "Failed to create job order"
//         );
//       setOpen(false);
//       setForm({
//         title: "",
//         company_name: "",
//         location: "",
//         description: "",
//         is_public: true,
//       });
//       fetchWithAuth("/job-orders/")
//         .then((res) => res.json())
//         .then(setJobOrders);
//     } catch (err) {
//       setError(err.message || "Failed to create job order");
//     }
//   };

//   const handleEdit = (job) => {
//     setEditForm({ ...job });
//     setEditOpen(true);
//   };
//   const handleEditSave = async () => {
//     setError("");
//     try {
//       const res = await fetchWithAuth(`/job-orders/${editForm.id}`, {
//         method: "PUT",
//         body: JSON.stringify(editForm),
//       });
//       if (!res.ok)
//         throw new Error(
//           (await res.json()).detail || "Failed to update job order"
//         );
//       setEditOpen(false);
//       fetchWithAuth("/job-orders/")
//         .then((res) => res.json())
//         .then(setJobOrders);
//     } catch (err) {
//       setError(err.message || "Failed to update job order");
//     }
//   };
//   const handleDelete = (id) => {
//     setDeleteId(id);
//     setDeleteOpen(true);
//   };
//   const handleDeleteConfirm = async () => {
//     setError("");
//     try {
//       const res = await fetchWithAuth(`/job-orders/${deleteId}`, {
//         method: "DELETE",
//       });
//       if (!res.ok) throw new Error("Failed to delete job order");
//       setDeleteOpen(false);
//       setDeleteId(null);
//       fetchWithAuth("/job-orders/")
//         .then((res) => res.json())
//         .then(setJobOrders);
//     } catch (err) {
//       setError(err.message || "Failed to delete job order");
//     }
//   };

//   const handleQuickAction = (action) => {
//     if (action === "scheduleEvent") {
//       setEventModalOpen(true);
//       return;
//     }
//     switch (action) {
//       case "createJob":
//         navigate("/admin/jobs?open=create");
//         break;
//       case "addCandidate":
//         navigate("/admin/candidates?open=create");
//         break;
//       case "scheduleEvent":
//         navigate("/admin/job-orders");
//         break;
//       case "newJobOrder":
//         navigate("/admin/job-orders?open=create");
//         break;
//       case "export":
//         navigate("/reports/export");
//         break;
//       default:
//         break;
//     }
//   };

//   if (!isAuthenticated || !auth?.access_token) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           height: "100vh",
//           bgcolor: "#F3F4F6",
//         }}
//       >
//         <Paper
//           elevation={1}
//           sx={{
//             px: 4,
//             py: 3,
//             borderRadius: 3,
//           }}
//         >
//           <Typography variant="h6">
//             You must be signed in to view the admin dashboard.
//           </Typography>
//         </Paper>
//       </Box>
//     );
//   }

//   const widgetLoaderSx = {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     minHeight: 140,
//     borderRadius: 2,
//     bgcolor: "background.paper",
//     boxShadow: "0 1px 3px rgba(15,23,42,0.08)",
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         minHeight: "100vh",
//         bgcolor: "#F3F4F6",
//       }}
//     >
//       <AdminSidebar selected="Dashboard" />
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           pl: { xs: 1.5, md: 3 },
//           pr: { xs: 1.5, md: 3 },
//           pt: 2,
//           pb: 3,
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         <Toolbar />
//         {location.pathname === "/admin" ? (
//           <Container
//             maxWidth="xl"
//             disableGutters
//             sx={{
//               mt: 1,
//             }}
//           >
//             {/* Page header */}
//             <Box
//               sx={{
//                 mb: 3,
//                 display: "flex",
//                 alignItems: { xs: "flex-start", sm: "center" },
//                 justifyContent: "space-between",
//                 flexWrap: "wrap",
//                 gap: 1.5,
//               }}
//             >
//               <Box>
//                 <Typography
//                   variant="h4"
//                   sx={{
//                     color: colors.purple,
//                     fontWeight: 700,
//                     letterSpacing: 0.2,
//                     mb: 0.5,
//                   }}
//                 >
//                   Admin Dashboard
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ maxWidth: 420 }}
//                 >
//                   High-level overview of your jobs, candidates and team
//                   activity.
//                 </Typography>
//               </Box>
//               <Tooltip
//                 title={
//                   showCustomize ? "Hide widget controls" : "Customize widgets"
//                 }
//               >
//                 <IconButton
//                   size="small"
//                   onClick={() => setShowCustomize((v) => !v)}
//                   sx={{
//                     borderRadius: 2,
//                     border: "1px solid",
//                     borderColor: showCustomize ? colors.purple : "divider",
//                     bgcolor: showCustomize
//                       ? "rgba(79,70,229,0.06)"
//                       : "background.paper",
//                     boxShadow: "0 1px 3px rgba(15,23,42,0.08)",
//                   }}
//                   aria-label="Customize dashboard widgets"
//                 >
//                   <SettingsOutlinedIcon
//                     fontSize="small"
//                     sx={{
//                       color: showCustomize ? colors.purple : "text.secondary",
//                     }}
//                   />
//                 </IconButton>
//               </Tooltip>
//             </Box>

//             {showCustomize && (
//               <Box
//                 sx={{
//                   mb: 2.5,
//                   p: 2,
//                   borderRadius: 2,
//                   bgcolor: "background.paper",
//                   boxShadow: "0 1px 3px rgba(15,23,42,0.08)",
//                 }}
//               >
//                 <CustomizableWidgets
//                   widgets={widgets}
//                   onToggle={handleToggleWidget}
//                 />
//               </Box>
//             )}

//             <Grid container spacing={3}>
//               <Grid item xs={12} md={8}>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: 3,
//                   }}
//                 >
//                   {widgets.find(
//                     (w) => w.key === "overview" && w.enabled
//                   ) &&
//                     (loadingOverview ? (
//                       <Box sx={widgetLoaderSx}>
//                         <CircularProgress size={28} />
//                       </Box>
//                     ) : (
//                       <OverviewCards stats={overviewStats} />
//                     ))}

//                   {widgets.find(
//                     (w) => w.key === "activity" && w.enabled
//                   ) &&
//                     (loadingActivity ? (
//                       <Box sx={widgetLoaderSx}>
//                         <CircularProgress size={28} />
//                       </Box>
//                     ) : (
//                       <RecentActivityFeed activities={activityFeed} />
//                     ))}

//                   {widgets.find(
//                     (w) => w.key === "performance" && w.enabled
//                   ) &&
//                     (loadingPerformance ? (
//                       <Box sx={widgetLoaderSx}>
//                         <CircularProgress size={28} />
//                       </Box>
//                     ) : (
//                       <JobOrderPerformance data={jobPerformance} />
//                     ))}

//                   {widgets.find((w) => w.key === "funnel" && w.enabled) &&
//                     (loadingFunnel ? (
//                       <Box sx={widgetLoaderSx}>
//                         <CircularProgress size={28} />
//                       </Box>
//                     ) : (
//                       <CandidatePipelineFunnel funnel={pipelineFunnel} />
//                     ))}
//                 </Box>
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: 3,
//                   }}
//                 >
//                   {widgets.find(
//                     (w) => w.key === "calendar" && w.enabled
//                   ) &&
//                     (loadingInterviews ? (
//                       <Box sx={widgetLoaderSx}>
//                         <CircularProgress size={28} />
//                       </Box>
//                     ) : (
//                       <InterviewCalendarWidget events={interviewEvents} />
//                     ))}

//                   {widgets.find((w) => w.key === "tasks" && w.enabled) &&
//                     (loadingTasks ? (
//                       <Box sx={widgetLoaderSx}>
//                         <CircularProgress size={28} />
//                       </Box>
//                     ) : (
//                       <TasksReminders tasks={tasks} onToggle={() => {}} />
//                     ))}

//                   {widgets.find((w) => w.key === "emails" && w.enabled) &&
//                     (loadingEmails ? (
//                       <Box sx={widgetLoaderSx}>
//                         <CircularProgress size={28} />
//                       </Box>
//                     ) : (
//                       <EmailNotificationSummary emails={emailSummary} />
//                     ))}

//                   {widgets.find((w) => w.key === "quick" && w.enabled) && (
//                     <Box>
//                       <QuickActions onAction={handleQuickAction} />
//                       <EventScheduleModalV2
//                         open={eventModalOpen}
//                         onClose={() => setEventModalOpen(false)}
//                         onSubmit={handleScheduleEvent}
//                       />
//                     </Box>
//                   )}

//                   {widgets.find((w) => w.key === "health" && w.enabled) &&
//                     (loadingSystemHealth ? (
//                       <Box sx={widgetLoaderSx}>
//                         <CircularProgress size={28} />
//                       </Box>
//                     ) : (
//                       <SystemHealth health={systemHealth} />
//                     ))}

//                   {widgets.find((w) => w.key === "ai" && w.enabled) &&
//                     (loadingAI ? (
//                       <Box sx={widgetLoaderSx}>
//                         <CircularProgress size={28} />
//                       </Box>
//                     ) : (
//                       <AIInsightsAnalytics insights={aiInsights} />
//                     ))}
//                 </Box>
//               </Grid>
//             </Grid>
//           </Container>
//         ) : null}
//       </Box>
//     </Box>
//   );
// }


import React, { useEffect, useState } from "react";
import { useAuth } from "./App";
import { API_URL } from "./config";
import {
  Container,
  Typography,
  Box,
  Grid,
  Toolbar,
  CircularProgress,
  IconButton,
  Tooltip,
  Paper,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import OverviewCards from "./components/admin_dashboard/OverviewCards";
import RecentActivityFeed from "./components/admin_dashboard/RecentActivityFeed";
import JobOrderPerformance from "./components/admin_dashboard/JobOrderPerformance";
import CandidatePipelineFunnel from "./components/admin_dashboard/CandidatePipelineFunnel";
import InterviewCalendarWidget from "./components/admin_dashboard/InterviewCalendarWidget";
import AIInsightsAnalytics from "./components/admin_dashboard/AIInsightsAnalytics";
import TasksReminders from "./components/admin_dashboard/TasksReminders";
import EmailNotificationSummary from "./components/admin_dashboard/EmailNotificationSummary";
import QuickActions from "./components/admin_dashboard/QuickActions";
import EventScheduleModalV2 from "./components/EventScheduleModalV2";
import SystemHealth from "./components/admin_dashboard/SystemHealth";
import CustomizableWidgets from "./components/admin_dashboard/CustomizableWidgets";
import { useLocation, useNavigate } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

export default function AdminDashboard() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const panelBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const [eventModalOpen, setEventModalOpen] = useState(false);
  const navigate = useNavigate();
  const { auth, isAuthenticated, fetchWithAuth } = useAuth();
  const location = useLocation();

  const [showCustomize, setShowCustomize] = useState(false);
  const [widgets, setWidgets] = useState([
    { key: "overview", label: "Overview Cards", enabled: true },
    { key: "activity", label: "Recent Activity", enabled: true },
    { key: "performance", label: "Job Order Performance", enabled: true },
    { key: "funnel", label: "Candidate Funnel", enabled: true },
    { key: "calendar", label: "Interview Calendar", enabled: true },
    { key: "ai", label: "AI Insights", enabled: true },
    { key: "tasks", label: "Tasks & Reminders", enabled: true },
    { key: "emails", label: "Email/Notification Summary", enabled: true },
    { key: "quick", label: "Quick Actions", enabled: true },
    { key: "health", label: "System Health", enabled: true },
  ]);

  const [overviewStats, setOverviewStats] = useState({
    jobOrders: 0,
    applications: 0,
    hires: 0,
    interviews: 0,
    newCandidates: 0,
  });
  const [activityFeed, setActivityFeed] = useState([]);
  const [jobPerformance, setJobPerformance] = useState([]);
  const [pipelineFunnel, setPipelineFunnel] = useState([]);
  const [interviewEvents, setInterviewEvents] = useState([]);
  const [aiInsights, setAiInsights] = useState({
    topMatched: [],
    parsingStats: {},
    diversity: {},
  });
  const [tasks, setTasks] = useState([]);
  const [emailSummary, setEmailSummary] = useState([]);
  const [systemHealth, setSystemHealth] = useState({
    api: "ok",
    integrations: [],
    errors: [],
  });

  const [loadingOverview, setLoadingOverview] = useState(false);
  const [loadingActivity, setLoadingActivity] = useState(false);
  const [loadingPerformance, setLoadingPerformance] = useState(false);
  const [loadingFunnel, setLoadingFunnel] = useState(false);
  const [loadingInterviews, setLoadingInterviews] = useState(false);
  const [loadingAI, setLoadingAI] = useState(false);
  const [loadingTasks, setLoadingTasks] = useState(false);
  const [loadingEmails, setLoadingEmails] = useState(false);
  const [loadingSystemHealth, setLoadingSystemHealth] = useState(false);

  const handleToggleWidget = (key) => {
    setWidgets((current) =>
      current.map((w) => (w.key === key ? { ...w, enabled: !w.enabled } : w))
    );
  };

  const handleScheduleEvent = async (eventData) => {
    try {
      const res = await fetchWithAuth(`${API_URL}/events/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(eventData),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail || "Failed to schedule event");
      }
      setEventModalOpen(false);
      return true;
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    let cancelled = false;

    async function fetchDashboardData() {
      if (!isAuthenticated || !auth?.access_token) return;

      setLoadingOverview(true);
      try {
        const res = await fetchWithAuth(`${API_URL}/dashboard/overview`);
        const data = await res.json();
        if (!cancelled) setOverviewStats(data);
      } catch {
        if (!cancelled) {
          setOverviewStats({
            jobOrders: 0,
            applications: 0,
            hires: 0,
            interviews: 0,
            newCandidates: 0,
          });
        }
      } finally {
        setLoadingOverview(false);
      }

      setLoadingActivity(true);
      try {
        const res = await fetchWithAuth(`${API_URL}/dashboard/activity`);
        const data = await res.json();
        if (!cancelled) setActivityFeed(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setActivityFeed([]);
      } finally {
        setLoadingActivity(false);
      }

      setLoadingPerformance(true);
      try {
        const res = await fetchWithAuth(`${API_URL}/dashboard/performance`);
        const data = await res.json();
        if (!cancelled) setJobPerformance(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setJobPerformance([]);
      } finally {
        setLoadingPerformance(false);
      }

      setLoadingFunnel(true);
      try {
        const res = await fetchWithAuth(`${API_URL}/dashboard/funnel`);
        const data = await res.json();
        if (!cancelled) setPipelineFunnel(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setPipelineFunnel([]);
      } finally {
        setLoadingFunnel(false);
      }

      setLoadingInterviews(true);
      try {
        const res = await fetchWithAuth(`${API_URL}/dashboard/interviews`);
        const data = await res.json();
        if (!cancelled) setInterviewEvents(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setInterviewEvents([]);
      } finally {
        setLoadingInterviews(false);
      }

      setLoadingAI(true);
      try {
        const res = await fetchWithAuth(`${API_URL}/dashboard/ai-insights`);
        const data = await res.json();
        if (!cancelled) setAiInsights(data);
      } catch {
        if (!cancelled) {
          setAiInsights({
            topMatched: [],
            parsingStats: {},
            diversity: {},
          });
        }
      } finally {
        setLoadingAI(false);
      }

      setLoadingTasks(true);
      try {
        const res = await fetchWithAuth(`${API_URL}/dashboard/tasks`);
        const data = await res.json();
        if (!cancelled) setTasks(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setTasks([]);
      } finally {
        setLoadingTasks(false);
      }

      setLoadingEmails(true);
      try {
        const res = await fetchWithAuth(`${API_URL}/dashboard/emails`);
        const data = await res.json();
        if (!cancelled) setEmailSummary(Array.isArray(data) ? data : []);
      } catch {
        if (!cancelled) setEmailSummary([]);
      } finally {
        setLoadingEmails(false);
      }

      setLoadingSystemHealth(true);
      try {
        const res = await fetchWithAuth(`${API_URL}/dashboard/system-health`);
        const data = await res.json();
        if (!cancelled) setSystemHealth(data);
      } catch {
        if (!cancelled) {
          setSystemHealth({ api: "ok", integrations: [], errors: [] });
        }
      } finally {
        setLoadingSystemHealth(false);
      }
    }

    fetchDashboardData();

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, auth, fetchWithAuth]);

  const handleQuickAction = (action) => {
    if (action === "scheduleEvent") {
      setEventModalOpen(true);
      return;
    }

    switch (action) {
      case "createJob":
        navigate("/admin/jobs?open=create");
        break;
      case "addCandidate":
        navigate("/admin/candidates?open=create");
        break;
      case "newJobOrder":
        navigate("/admin/job-orders?open=create");
        break;
      case "export":
        navigate("/reports/export");
        break;
      default:
        break;
    }
  };

  if (!isAuthenticated || !auth?.access_token) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          bgcolor: pageBg,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            px: 4,
            py: 3,
            borderRadius: "22px",
            border: `1px solid ${border}`,
            background: panelBg,
          }}
        >
          <Typography sx={{ color: text, fontWeight: 700 }}>
            You must be signed in to view the admin dashboard.
          </Typography>
        </Paper>
      </Box>
    );
  }

  const widgetLoaderSx = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 140,
    borderRadius: "22px",
    bgcolor: panelBg,
    border: `1px solid ${border}`,
    boxShadow: dark
      ? "0 20px 50px rgba(0,0,0,0.18)"
      : "0 10px 30px rgba(15,23,42,0.04)",
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: pageBg,
      }}
    >
      <AdminSidebar selected="Dashboard" />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pl: { xs: 1.5, md: 3 },
          pr: { xs: 1.5, md: 3 },
          pt: 2,
          pb: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />

        {location.pathname === "/admin" ? (
          <Container maxWidth="xl" disableGutters sx={{ mt: 1 }}>
            <Box
              sx={{
                mb: 3,
                overflow: "hidden",
                borderRadius: "28px",
                border: `1px solid ${border}`,
                background: dark
                  ? `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
                  : `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
                boxShadow: dark
                  ? "0 32px 80px rgba(0,0,0,0.30)"
                  : "0 32px 80px rgba(15,15,26,0.08)",
              }}
            >
              <Box
                sx={{
                  p: { xs: 3, sm: 4, md: 5 },
                  display: "flex",
                  alignItems: { xs: "flex-start", sm: "center" },
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 1.5,
                }}
              >
                <Box>
                  <SectionEyebrow color={accent}>AjiraHQ · Admin Dashboard</SectionEyebrow>
                  <Typography
                    sx={{
                      mt: 2,
                      color: text,
                      fontWeight: 800,
                      fontSize: "clamp(32px, 4vw, 48px)",
                      lineHeight: 1.06,
                      letterSpacing: "-0.03em",
                      mb: 0.75,
                    }}
                  >
                    Recruitment operations at a glance.
                  </Typography>
                  <Typography
                    sx={{
                      color: mid,
                      fontSize: "15px",
                      lineHeight: 1.8,
                      maxWidth: 560,
                    }}
                  >
                    Monitor hiring activity, candidate flow, interview volume,
                    system health, and follow-up actions from one central view.
                  </Typography>
                </Box>

                <Tooltip
                  title={showCustomize ? "Hide widget controls" : "Customize widgets"}
                >
                  <IconButton
                    size="small"
                    onClick={() => setShowCustomize((v) => !v)}
                    sx={{
                      borderRadius: "14px",
                      border: `1px solid ${
                        showCustomize ? alpha(accent, 0.24) : border
                      }`,
                      bgcolor: showCustomize
                        ? alpha(accent, dark ? 0.14 : 0.08)
                        : panelBg,
                      color: showCustomize ? accent : mid,
                      boxShadow: dark
                        ? "0 10px 24px rgba(0,0,0,0.18)"
                        : "0 8px 20px rgba(15,23,42,0.05)",
                    }}
                    aria-label="Customize dashboard widgets"
                  >
                    <SettingsOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            {showCustomize && (
              <Box
                sx={{
                  mb: 2.5,
                  p: 2,
                  borderRadius: "22px",
                  bgcolor: panelBg,
                  border: `1px solid ${border}`,
                  boxShadow: dark
                    ? "0 20px 50px rgba(0,0,0,0.18)"
                    : "0 10px 30px rgba(15,23,42,0.04)",
                }}
              >
                <CustomizableWidgets
                  widgets={widgets}
                  onToggle={handleToggleWidget}
                />
              </Box>
            )}

            <Grid container spacing={3}>
              <Grid item xs={12} md={8}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                  {widgets.find((w) => w.key === "overview" && w.enabled) &&
                    (loadingOverview ? (
                      <Box sx={widgetLoaderSx}>
                        <CircularProgress size={28} sx={{ color: accent }} />
                      </Box>
                    ) : (
                      <OverviewCards stats={overviewStats} />
                    ))}

                  {widgets.find((w) => w.key === "activity" && w.enabled) &&
                    (loadingActivity ? (
                      <Box sx={widgetLoaderSx}>
                        <CircularProgress size={28} sx={{ color: accent }} />
                      </Box>
                    ) : (
                      <RecentActivityFeed activities={activityFeed} />
                    ))}

                  {widgets.find((w) => w.key === "performance" && w.enabled) &&
                    (loadingPerformance ? (
                      <Box sx={widgetLoaderSx}>
                        <CircularProgress size={28} sx={{ color: accent }} />
                      </Box>
                    ) : (
                      <JobOrderPerformance data={jobPerformance} />
                    ))}

                  {widgets.find((w) => w.key === "funnel" && w.enabled) &&
                    (loadingFunnel ? (
                      <Box sx={widgetLoaderSx}>
                        <CircularProgress size={28} sx={{ color: accent }} />
                      </Box>
                    ) : (
                      <CandidatePipelineFunnel funnel={pipelineFunnel} />
                    ))}
                </Box>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                  {widgets.find((w) => w.key === "calendar" && w.enabled) &&
                    (loadingInterviews ? (
                      <Box sx={widgetLoaderSx}>
                        <CircularProgress size={28} sx={{ color: accent }} />
                      </Box>
                    ) : (
                      <InterviewCalendarWidget events={interviewEvents} />
                    ))}

                  {widgets.find((w) => w.key === "tasks" && w.enabled) &&
                    (loadingTasks ? (
                      <Box sx={widgetLoaderSx}>
                        <CircularProgress size={28} sx={{ color: accent }} />
                      </Box>
                    ) : (
                      <TasksReminders tasks={tasks} onToggle={() => {}} />
                    ))}

                  {widgets.find((w) => w.key === "emails" && w.enabled) &&
                    (loadingEmails ? (
                      <Box sx={widgetLoaderSx}>
                        <CircularProgress size={28} sx={{ color: accent }} />
                      </Box>
                    ) : (
                      <EmailNotificationSummary emails={emailSummary} />
                    ))}

                  {widgets.find((w) => w.key === "quick" && w.enabled) && (
                    <Box>
                      <QuickActions onAction={handleQuickAction} />
                      <EventScheduleModalV2
                        open={eventModalOpen}
                        onClose={() => setEventModalOpen(false)}
                        onSubmit={handleScheduleEvent}
                      />
                    </Box>
                  )}

                  {widgets.find((w) => w.key === "health" && w.enabled) &&
                    (loadingSystemHealth ? (
                      <Box sx={widgetLoaderSx}>
                        <CircularProgress size={28} sx={{ color: accent }} />
                      </Box>
                    ) : (
                      <SystemHealth health={systemHealth} />
                    ))}

                  {widgets.find((w) => w.key === "ai" && w.enabled) &&
                    (loadingAI ? (
                      <Box sx={widgetLoaderSx}>
                        <CircularProgress size={28} sx={{ color: accent }} />
                      </Box>
                    ) : (
                      <AIInsightsAnalytics insights={aiInsights} />
                    ))}
                </Box>
              </Grid>
            </Grid>
          </Container>
        ) : null}
      </Box>
    </Box>
  );
}